import { ContentPage } from '../components/content-page';
import { ServiceList } from '../components/services/service-list';
import { ServiceDescription } from '../components/services/service-description';
import { ServicesDataProvider, useServices } from '../providers/services-provider';
import { useLocation } from 'react-router-dom';
import { PageMetadata } from '../components/page-metadata';

function ServicesPageMetadata() {
    const { service, selectedKey, detailError } = useServices();
    return <PageMetadata catalogueRecord={!detailError && service && service.service_key === selectedKey ? {
        key: service.service_key, name: service.name, description: service.content, descriptionIsHtml: true
    } : null} />;
}

export default function ServicesPage() {
    const { search } = useLocation();
    const hasSelectedService = !!new URLSearchParams(search).get('service');
    return <ServicesDataProvider>
        <ServicesPageMetadata />
        <div style={{ flex: 1, display: 'flex', minHeight: 0, width: '100%', minWidth: 0 }}>
            <ContentPage pageId="services" pageTitle="Services" pageTitleLevel="h1" publicPageTitle leftPanelTitle="Available services"
                rightPanelTitle="Service overview and details" mobileTabs initialMobilePanel={hasSelectedService ? 'right' : 'left'}
                leftContent={(showDetails) => <ServiceList onServiceSelected={showDetails} />}
                rightContent={(showList) => <ServiceDescription onBackToList={showList} />} leftContentPercent={35} />
        </div>
    </ServicesDataProvider>;
}
